"use strict";
/**
 * From https://alexn.org/blog/2020/04/21/javascript-semaphore.html
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.AsyncSemaphore = void 0;
var AsyncSemaphore = /** @class */ (function () {
    function AsyncSemaphore(workersCount) {
        this.workersCount = workersCount;
        if (workersCount <= 0)
            throw new Error('workersCount must be positive');
        this._available = workersCount;
        this._upcoming = [];
        this._heads = [];
        this._refreshComplete();
    }
    AsyncSemaphore.prototype.withLock = function (f) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._acquire()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._execWithRelease(f)];
                }
            });
        });
    };
    AsyncSemaphore.prototype.withLockRunAndForget = function (f) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._acquire()];
                    case 1:
                        _a.sent();
                        // Ignoring returned promise on purpose!
                        this._execWithRelease(f);
                        return [2 /*return*/];
                }
            });
        });
    };
    AsyncSemaphore.prototype.awaitTerminate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._available < this.workersCount) {
                    return [2 /*return*/, this._completePr];
                }
                return [2 /*return*/];
            });
        });
    };
    AsyncSemaphore.prototype._execWithRelease = function (f) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        return [4 /*yield*/, f()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this._release();
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AsyncSemaphore.prototype._queue = function () {
        if (!this._heads.length) {
            this._heads = this._upcoming.reverse();
            this._upcoming = [];
        }
        return this._heads;
    };
    AsyncSemaphore.prototype._acquire = function () {
        if (this._available > 0) {
            this._available -= 1;
            return undefined;
        }
        else {
            var fn_1 = function () {
                /***/
            };
            var p = new Promise(function (ref) {
                fn_1 = ref;
            });
            this._upcoming.push(fn_1);
            return p;
        }
    };
    AsyncSemaphore.prototype._release = function () {
        var queue = this._queue();
        if (queue.length) {
            var fn = queue.pop();
            if (fn)
                fn();
        }
        else {
            this._available += 1;
            if (this._available >= this.workersCount) {
                var fn = this._completeFn;
                this._refreshComplete();
                fn();
            }
        }
    };
    AsyncSemaphore.prototype._refreshComplete = function () {
        var fn = function () {
            /***/
        };
        this._completePr = new Promise(function (r) {
            fn = r;
        });
        this._completeFn = fn;
    };
    return AsyncSemaphore;
}());
exports.AsyncSemaphore = AsyncSemaphore;
